import { Box, Typography } from '@mui/material'
import FigmaIconFrame from '../common/FigmaIconFrame'

const ICON_BG_COLORS = [
  'rgba(183,7,7,0.12)',
  'rgba(183,142,7,0.12)',
  'rgba(115,183,7,0.12)',
  'rgba(7,183,183,0.12)',
  'rgba(7,30,183,0.12)',
  'rgba(183,7,171,0.12)',
]

function InitiativeCard({ title, iconSrc, iconBgColor }) {
  return (
    <Box
      sx={{
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        height: '100%',
        minHeight: { xs: 'auto', md: 112 },
      }}
    >
      <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        <FigmaIconFrame src={iconSrc} bgColor={iconBgColor ?? ICON_BG_COLORS[0]} boxSize={64} innerSize={32} />
        <Typography
          sx={{
            fontSize: { xs: 18, md: 24 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            flex: 1,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  )
}

export default function DimensionInitiativesSection({ initiatives = [] }) {
  if (initiatives.length === 0) return null

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4, lg: 6 },
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 1.2,
          fontWeight: 400,
          color: '#111',
          flexShrink: 0,
          position: { md: 'sticky' },
          top: { md: 0 },
        }}
      >
        Our Initiatives
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          width: { xs: '100%', lg: 1000 },
          maxWidth: '100%',
        }}
      >
        {[0, 2, 4].map((start) => {
          const row = initiatives.slice(start, start + 2)
          if (row.length === 0) return null
          return (
            <Box
              key={start}
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: '24px',
              }}
            >
              {row.map((item, index) => (
                <InitiativeCard
                  key={item.title}
                  title={item.title}
                  iconSrc={item.iconSrc}
                  iconBgColor={item.iconBgColor ?? ICON_BG_COLORS[(start + index) % ICON_BG_COLORS.length]}
                />
              ))}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
